import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "src/app-legacy/core/services/auth.service";

/**
 * Ensures that a user can only access a route if they are authenticated
 * @returns True is the user is authenticated or a url tree to redirect to the login page
 */
export const authGuard: CanActivateFn = () => {
	const auth = inject(AuthService);
	const router = inject(Router);

	if (auth.getAccessToken()) {
		return true;
	}

	return router.createUrlTree(["/auth/login"]);
};
